import { render, staticRenderFns } from "./Suggest.vue?vue&type=template&id=9c3f3418&scoped=true&"
import script from "./Suggest.vue?vue&type=script&lang=js&"
export * from "./Suggest.vue?vue&type=script&lang=js&"
import style0 from "./Suggest.vue?vue&type=style&index=0&id=9c3f3418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3f3418",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c3f3418')) {
      api.createRecord('9c3f3418', component.options)
    } else {
      api.reload('9c3f3418', component.options)
    }
    module.hot.accept("./Suggest.vue?vue&type=template&id=9c3f3418&scoped=true&", function () {
      api.rerender('9c3f3418', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Suggest.vue"
export default component.exports